'use client'

import React from 'react'
import { Label } from '@/components/ui/label'
import { Input } from '@/components/ui/input'
import { costOptions, periodOptions } from '../constants'

interface BudgetScheduleStepProps {
  formData: {
    period: string
    startDate: string
    cost: string
  }
  onChange: (field: string, value: any) => void
  onNext: () => void
  onPrevious: () => void
}

export const BudgetScheduleStep: React.FC<BudgetScheduleStepProps> = ({ formData, onChange }) => {
  return (
    <div className="space-y-8">
      {/* 상단 헤더 */}
      <div className="space-y-1">
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">예산 · 일정</h2>
        <p className="text-sm text-gray-600">대략적인 범위를 입력하면, 더 정확한 제안이 옵니다.</p>
        <p className="text-xs text-blue-600">예산/기간은 ‘범위’로만 입력해도 충분합니다.</p>
      </div>

      <div className="space-y-6">
        {/* 섹션 1) 예산(필수) */}
        <div className="space-y-2">
          <Label htmlFor="cost">예산 범위 <span className="text-blue-600">*</span></Label>
          <select
            id="cost"
            value={formData.cost}
            onChange={(e) => onChange('cost', e.target.value)}
            className="w-full h-11 rounded-xl border border-gray-200 px-4 text-sm"
          >
            <option value="">선택해주세요</option>
            {costOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>

        {/* 섹션 2) 기간(필수) */}
        <div className="space-y-2">
          <Label htmlFor="period">희망 기간 <span className="text-blue-600">*</span></Label>
          <select
            id="period"
            value={formData.period}
            onChange={(e) => onChange('period', e.target.value)}
            className="w-full h-11 rounded-xl border border-gray-200 px-4 text-sm"
          >
            <option value="">선택해주세요</option>
            {periodOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>

        {/* 섹션 3) 착수일(선택) */}
        <div className="space-y-2">
          <Label htmlFor="startDate">착수 희망일 <span className="text-xs text-gray-500">(선택)</span></Label>
          <Input
            id="startDate"
            type="date"
            value={formData.startDate}
            onChange={(e) => onChange('startDate', e.target.value)}
            className="h-11 rounded-xl border border-gray-200 px-4 text-sm"
          />
          <p className="text-xs text-gray-500">정확하지 않아도 됩니다. 대략적인 희망 시점만 적어주세요.</p>
        </div>
      </div>
    </div>
  )
}
